import React from "react";
import { connect } from "react-redux";
import { Table, TableContainer } from "../styles";
import { VrReportOngoing } from "../../../actions/vrReportOngoing";

type Props = { vrReportsOngoing: VrReportOngoing[] };

function VrReportsOngoing({ vrReportsOngoing }: Props) {
  return (
    <TableContainer>
      <Table>
        <thead>
          <tr>
            <th>Row Number</th>
            <th>Type</th>
            <th>PBSE Version</th>
            <th>Is USA</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {vrReportsOngoing.map((row, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{row.type}</td>
              <td>{row.pbse_version}</td>
              <td>{row.is_usa ? "Yes" : "No"}</td>
              <td>{row.count}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
}

const mapStateToProps = (state: any) => ({
  vrReportsOngoing: state.entities.vrReportsOngoing.vrReportsOngoing
});

export default connect(mapStateToProps)(VrReportsOngoing);
